import { Paper } from '../primitives/paper.js'
import React, { useRef } from 'react'
import type { HTMLAttributes, JSX, RefObject } from 'react'
import Draggable from 'react-draggable'
import dialogStyles from '../primitives/dialog.module.css'
import DialogTitle from './dialog-title.js'
import styles from './draggable-dialog.module.css'

interface DraggableDialogProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  open: boolean
  title: string | JSX.Element
  children?: React.ReactNode
  onClose: (ev: React.SyntheticEvent) => void
}

export const DraggableDialog: React.FC<DraggableDialogProps> = ({
  open = false,
  title,
  onClose,
  children,
  className,
  style,
  ...restProps
}) => {
  const ref = useRef<HTMLDivElement>(null)

  if (open === false) {
    return null
  }

  const paperClasses = [styles.paper, className].filter(Boolean).join(' ')

  return (
    <Draggable nodeRef={ref as RefObject<HTMLElement>}>
      <Paper {...restProps} ref={ref} className={paperClasses} elevation={4} style={style}>
        <DialogTitle className={styles.titleDrag} onClose={onClose}>
          {title}
        </DialogTitle>
        <div className={dialogStyles.content}>{children}</div>
      </Paper>
    </Draggable>
  )
}
